/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OrganizationResponse } from './organizationResponse';
import type { SwitchOrgResponseRole } from './switchOrgResponseRole';

export interface SwitchOrgResponse {
  organization: OrganizationResponse;
  role: SwitchOrgResponseRole;
  /** WorkOS organization id returned separately so the frontend can refresh into the selected org context without exposing WorkOS ids on OrganizationResponse. */
  workos_org_id: string;
}
